<template>
  <div class="ad_page">
    <img class="ad_bg" src="@/assets/images/activity/ruqi/ruqi.png" alt="" />
    <img
      class="ad_code"
      src="@/assets/images/activity/ruqi/ruqi_code.png"
      alt=""
    />
  </div>
</template>
<script>
export default {
  metaInfo() {
    return {
      title: "如祺出行",
      titleTemplate: (title) => {
        return title;
      },
    };
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.ad_page {
  background: #ffda44;
  position: relative;
  height: 100%;
  width: 100%;
}
.ad_bg {
  width: 100%;
  display: block;
}
.ad_code {
  width: 50%;
  display: block;
  position: absolute;
  left: 50%;
  top: 52vw;
  transform: translateX(-50%);
}
</style>
<style>
#app {
  height: 100%;
}
</style>
